import React from 'react'
import PropTypes from 'prop-types'

import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

ReportDetails.propTypes = {
  cdLm: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  dsLm: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired,
  ]),
  qtStockStartOfMonth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  qtStockEndOfMonth: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  dsStockStartOfMonthLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  dsStockEndOfMonthLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  dsAdditionalInfoLabel: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  cdAdditionalInfo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dsAdditionalInfo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default function ReportDetails({
  cdLm,
  dsLm,
  qtStockStartOfMonth,
  qtStockEndOfMonth,
  dsStockStartOfMonthLabel,
  dsStockEndOfMonthLabel,
  dsAdditionalInfoLabel,
  cdAdditionalInfo,
  dsAdditionalInfo,
}) {
  const lmFullText =
    cdLm && dsLm ? `${cdLm} - ${dsLm}` : cdLm || dsLm || ''

  return (
    <div className='report-details-container'>
      <Col xs={8}>
        <Row>
          <label
            className='report-details-primary-info'
            title={lmFullText}
          >
            <span className='strong'>
              {cdLm}
              {cdLm && dsLm ? ' - ' : ''}
            </span>
            {dsLm}
          </label>
        </Row>

        <Row>
          <label>
            <span className='strong'>
              {dsAdditionalInfoLabel && cdAdditionalInfo
                ? dsAdditionalInfoLabel
                : ''}{' '}
              {cdAdditionalInfo}
              {cdAdditionalInfo && dsAdditionalInfo ? ' - ' : ''}
            </span>
            {dsAdditionalInfo}
          </label>
        </Row>
      </Col>

      <Col xs={4}>
        <div className='kardex-stock-quadrant'>
          <Row>
            <label className='kardex-stock-line'>
              <span className='strong'>
                {dsStockStartOfMonthLabel}:{' '}
              </span>
              <span>
                {qtStockStartOfMonth !== undefined &&
                qtStockStartOfMonth !== null
                  ? qtStockStartOfMonth
                  : '-'}
              </span>
            </label>
          </Row>

          <Row>
            <label className='kardex-stock-line'>
              <span className='strong'>
                {dsStockEndOfMonthLabel}:{' '}
              </span>
              <span>
                {qtStockEndOfMonth !== undefined && qtStockEndOfMonth !== null
                  ? qtStockEndOfMonth
                  : '-'}
              </span>
            </label>
          </Row>
        </div>
      </Col>
    </div>
  )
}
